"use strict";
exports.__esModule = true;
var React = require("react");
var Contact = function () {
    return (React.createElement("div", null,
        React.createElement("a", { href: "https://twitter.com/TheoTam4", className: "twitter-follow-button", "data-show-count": "false" }, "Follow @TheoTam4")));
};
exports["default"] = Contact;
